import { ProjectPlanPriority, ProjectPlanStatus } from 'api/models';

export const ProjectPlanStatusConfig: Partial<Record<
  ProjectPlanStatus,
  { key: string; title: string; color: string }
>> = {
  [ProjectPlanStatus.Pending]: { key: 'pending', title: 'Pending', color: 'orange' },
  [ProjectPlanStatus.InProgress]: { key: 'in-progress', title: 'In Progress', color: 'blue' },
  [ProjectPlanStatus.Completed]: { key: 'completed', title: 'Completed', color: 'green' },
  [ProjectPlanStatus.Cancelled]: { key: 'cancelled', title: 'Cancelled', color: 'red' },
};

export const getProjectPlanStatusColor = (status: ProjectPlanStatus) => {
  switch (status) {
    case ProjectPlanStatus.Pending: // Pending
      return '#13c2c2';
    case ProjectPlanStatus.InProgress: // In Progress
      return '#1890ff';
    case ProjectPlanStatus.Completed: // Completed
      return '#52c41a';
    case ProjectPlanStatus.Cancelled: // Cancelled
      return '#ff4d4f';
    default:
      return '#d9d9d9';
  }
};

export const getProjectPlanStatusName = (status: ProjectPlanStatus) => {
  return ProjectPlanStatusConfig[status];
};

export const getPriorityColor = (priority: number | null): string => {
  switch (priority) {
    case ProjectPlanPriority.High:
      return '#ff4d4f';
    case ProjectPlanPriority.Medium:
      return '#faad14';
    case ProjectPlanPriority.Low:
      return '#52c41a';
    default:
      return '#d9d9d9';
  }
};

export const getPriorityName = (priority: number | null): { key: string; title: string } => {
  switch (priority) {
    case ProjectPlanPriority.High:
      return { key: 'high', title: 'High' };
    case ProjectPlanPriority.Medium:
      return { key: 'medium', title: 'Medium' };
    case ProjectPlanPriority.Low:
      return { key: 'low', title: 'Low' };
    default:
      return { key: 'none', title: 'None' };
  }
};
